/** Periodicidades da aplicação */
export interface Periodicidade {
    id: number;
    nome: string;
    sigla: string;
}

export const periodicidadeDiaria: Periodicidade = {
    id: 1,
    nome: 'Diária',
    sigla: 'D'
};

export const periodicidadeSemanal: Periodicidade = {
    id: 2,
    nome: 'Semanal',
    sigla: 'SM'
};

export const periodicidadeMensal: Periodicidade = {
    id: 3,
    nome: 'Mensal',
    sigla: 'M'
};

export const periodicidadeTrimestral: Periodicidade = {
    id: 4,
    nome: 'Trimestral',
    sigla: 'T'
};

export const periodicidadeSemestral: Periodicidade = {
    id: 5,
    nome: 'Semestral',
    sigla: 'S'
};

export const periodicidadeAnual: Periodicidade = {
    id: 6,
    nome: 'Anual',
    sigla: 'A'
};

export const periodicidadePeriodo: Periodicidade = {
    id: 7,
    nome: 'Período',
    sigla: 'P'
};

export const periodicidadeTodoPeriodo: Periodicidade = {
    id: 8,
    nome: 'Todo Período',
    sigla: 'TP'
};

export const periodicidades: Periodicidade[] = [
    periodicidadeDiaria,
    periodicidadeSemanal,
    periodicidadeMensal,
    periodicidadeTrimestral,
    periodicidadeSemestral,
    periodicidadeAnual,
    periodicidadePeriodo,
    periodicidadeTodoPeriodo
];


/** Verifica se a periodicidade é Diária */
export function isPeriodicidadeDiaria(periodicidade: number): boolean {
    if (!periodicidade) {
        return false;
    }
    return periodicidade === periodicidadeDiaria.id;
}

/** Verifica se a periodicidade é Semanal */
export function isPeriodicidadeSemanal(periodicidade: number): boolean {
    if (!periodicidade) {
        return false;
    }
    return periodicidade === periodicidadeSemanal.id;
}

/** Verifica se a periodicidade é Mensal */
export function isPeriodicidadeMensal(periodicidade: number): boolean {
    if (!periodicidade) {
        return false;
    }
    return periodicidade === periodicidadeMensal.id;
}

/** Verifica se a periodicidade é Trimestral */
export function isPeriodicidadeTrimestral(periodicidade: number): boolean {
    if (!periodicidade) {
        return false;
    }
    return periodicidade === periodicidadeTrimestral.id;
}

/** Verifica se a periodicidade é Semestral */
export function isPeriodicidadeSemestral(periodicidade: number): boolean {
    if (!periodicidade) {
        return false;
    }
    return periodicidade === periodicidadeSemestral.id;
}

/** Verifica se a periodicidade é Anual */
export function isPeriodicidadeAnual(periodicidade: number): boolean {
    if (!periodicidade) {
        return false;
    }
    return periodicidade === periodicidadeAnual.id;
}

/** Verifica se a periodicidade é Período */
export function isPeriodicidadePeriodo(periodicidade: number): boolean {
    if (!periodicidade) {
        return false;
    }
    return periodicidade === periodicidadePeriodo.id;
}

/** Verifica se a periodicidade é todo o período */
export function isPeriodicidadeTodoPeriodo(periodicidade: number): boolean {
    if (!periodicidade) {
        return false;
    }
    return periodicidade === periodicidadeTodoPeriodo.id;
}
